import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5 pb-0 justify-content-end lang-header" }
const _hoisted_3 = { class: "menu-item-wrapper language-selector" }
const _hoisted_4 = {
  class: "menu-item",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "selected-language d-flex flex-wrap align-items-center" }
const _hoisted_7 = { class: "symbol symbol-20px me-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_9 = { class: "menu-item-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_12 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "",
            class: "menu-link btn-profile-default outside-click",
            onClick: _ctx.languageHandler
          }, {
            default: _withCtx(() => [
              _createVNode("span", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _createVNode("img", {
                    src: _ctx.currentLangugeLocale,
                    alt: "YellowBeard"
                  }, null, 8, ["src"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode("div", {
            class: ["menu-sub menu-sub-dropdown w-150px", { 'language-active': _ctx.languageArea }]
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
              return (_openBlock(), _createBlock("div", {
                class: "menu-item",
                key: locale.id
              }, [
                (locale.value == 'en' || locale.value == _ctx.active_locale)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.setLang(locale.value, locale?.flag)),
                      href: "#",
                      class: ["menu-link d-flex", {
                                    active: _ctx.currentLanguage(locale.locale)
                                }]
                    }, [
                      _createVNode("span", _hoisted_7, [
                        _createVNode("img", {
                          class: "rounded-1",
                          src: locale?.flag,
                          alt: "YellowBeard"
                        }, null, 8, ["src"])
                      ]),
                      _createTextVNode(" " + _toDisplayString(locale.label), 1)
                    ], 10, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 2)
        ])
      ])
    ]),
    _createVNode(_component_Search, {
      selectData: _ctx.filterObject,
      filter: true,
      filterPlaceholder: 'message.SELECT',
      onSearch: _ctx.searchHandler,
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.get_language(1, true))),
      onExportFile: _ctx.exportFile
    }, null, 8, ["selectData", "filterPlaceholder", "onSearch", "onExportFile"]),
    _createVNode(_component_Table, {
      loading: _ctx.loader,
      columns: _ctx.columns,
      rows: _ctx.languages,
      pagination: _ctx.pagination,
      padding: 5,
      onHandleCurrentChange: _ctx.handleCurrentChange
    }, {
      "cell-translation": _withCtx(({row:item}) => [
        _createTextVNode(_toDisplayString(JSON.parse(item?.translation)[`${_ctx.system_locale}`]?.name), 1)
      ]),
      "cell-actions": _withCtx(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_8,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_9, [
              (_ctx.$can('edit_language_translation'))
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleEdit(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_11,
                      _createTextVNode(_toDisplayString(_ctx.$t('message.EDIT')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('edit_language_translation'))
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleDelete(item.id)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_ctx.$t('message.DELETE')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange"])
  ]))
}